import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../App.scss";

const Details = (props) => {
  const [pets, setPets] = useState([]);

  const gameLang = document.documentElement.lang || process.env.REACT_APP_LANG_TYPE;
  var mainTextClass = "";
  var hitPlayClass = "";
  var backgrndTop1 = "";
  var backgrndTwo1 = "";
  var cartoonPlayNow = "";
  var onHover = "";
  var gameTitle = "";
  var gameSecondTitle = "";
  var viewportSizeWarning = "";

  if (gameLang === "en") {
    mainTextClass = "main_text wizard_english_text";
    hitPlayClass = "hit_play set_even_higher";
    backgrndTop1 = "bckgrnd_top_1 bckgrnd_top_1_port";
    backgrndTwo1 = "bckgrnd_two_1 bckgrnd_two_1_port";
    cartoonPlayNow = "cartoon_play_now cartoon_play_now_port";
    onHover = "on_hover on_hover_port";
    gameTitle = "Multiple choice game";
    gameSecondTitle = "Build a Byzantine church";
    viewportSizeWarning =
      "In order to play this game, your viewport size has to be at least 700px wide and 525px high.";
  } else {
    mainTextClass = "main_text";
    hitPlayClass = "hit_play set_even_higher";
    backgrndTop1 = "bckgrnd_top_1 bckgrnd_top_1_port";
    backgrndTwo1 = "bckgrnd_two_1 bckgrnd_two_1_port";
    cartoonPlayNow = "cartoon_play_now cartoon_play_now_port";
    onHover = "on_hover on_hover_port";
    gameTitle = "Στο παιχνίδι αυτό θα περιηγηθείς στο Ανάκτορο του Νέστορα.";
    viewportSizeWarning =
      "Για να μπορείτε να παίξετε το παιχνίδι απαιτούνται διαστάσεις οθόνης τουλάχιστον 700px πλάτος και 525px ύψος.";
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <div className="intro">
        <div className="intro-container">
          <div className={mainTextClass}>
            <div className="main_title">{gameTitle}</div>
            <div className="main_paragraph">{props.main_text}</div>
            <div className="instructions">{props.main_text2}</div>
          </div>
          <div className="start-game-buttons">
            <Link to={`/dimotiko`} className="pet">
              <button className={hitPlayClass}>Μαθητές Δημοτικού</button>
            </Link>
            <Link to={`/lykeio`} className="pet">
              <button className={hitPlayClass}>Μαθητές Γυμνασίου / Λυκείου</button>
            </Link>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Details;
